import React from "react";
import styles from "../styles/NewsItem.module.css";
import { Link } from "react-router-dom";

export default function NewsItem({ news }) {
  return (
    // ✅ keep original 4-column float grid styling
    <div className={styles.news}>
      <Link to={`/chinese-zodiac/${news.slug}`} title={`Zodiac ${news.name}`}>
        <div className={styles.newsimg}>
          <img
            src={news.image || "/no-image.png"}
            width={160}
            height={160}
            alt={`Zodiac ${news.name}`}
          />
        </div>
        <div className={styles.info}>
          <h3>{news.name}</h3>
          <p>Born in:</p>
          <p>{news.date}</p>
        </div>
      </Link>
    </div>
  );
}
